import React, { Suspense, useContext, useEffect, useState } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import Button from "../../components/core/EPL_Button_Think";
import ErrorModal from "../../modals/ErrorModal";
// import useMediaQuery from '../../shared/hooks/useMediaQuery';
import useMediaQuery from "../../hooks/useMediaQuery";
// import VendorService from '../../shared/services/VendorService';
// import poll from '../../shared/utils/poll';
// import sendRequest from '../../shared/utils/sendRequest';
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import sendRequest from "../../utils/sendRequest";
// import { filterAddress, isValidAddress } from '../../shared/validations/Address';
// import { isValidCity } from '../../shared/validations/City';
// import { isValidPincode } from '../../shared/validations/Pincode';
// import Progress from '../progress/Progress';
// import Summary from '../summary/Summary';
import { useLocation } from "react-router-dom";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import appendRupee from "../../utils/appendRupee";
import { encrypt } from "../../utils/crypto";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
// import referenceArt from "../../assets/svg/EPL_think_svg/Reference_art.svg";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import { REVIEW_IPO, SEND_EMAIL_OTP, VERIFY_EMAIL_OTP } from "../../Config";
import { isValidOTP } from "../../shared/validations/OTP";
import SubTitle from "../../components/core/SubTitle";
import OTPInput from "../../components/base/OtpInput.js";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { StyleWrapper } from "./_styles/StyleWrapper";
import { updateLead } from "../../shared/services/crm";
import {
  ZumigoFailed,
  ForeclosureChargesModal,
  IncorrectOtpModal,
  MaxOtpRetryModal,
  OtpExpiredModal,
  ResendOtpEmailModal,
  CheckInternetModal,
} from "../other-pages/Modals/AllModal";
import CheckField from "../../components/form/CheckField.js";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import { encryptedData } from "../../utils/index.js";
import FallbackLoader from "../../components/FallbackLoader.js";
import { userConsentStatus } from "../../utils/userConsentStatus.js";
import PdfModal from "../../modals/PdfModal.js";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const ReviewDetails = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const [modal, setModal] = useState("");
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(true);
  const [interestRate, setInterestRate] = useState(12);
  const [roiApprovedEMI, setROIApprovedEMI] = useState(10); //constant.ROI_EMI.value);
  // const [roiApprovedEMI, setROIApprovedEMI] = useState((constant) => constant.ROI_EMI.value || 0);
  const [maxApprovedLoanAmount, setMaxApprovedLoanAmount] = useState(1000000); // constant.MAX_LOAN_AMT.value);
  const insuranceAmount = 1500;
  const [approvedRoi, setApprovedRoi] = useState("00");
  const [maxTenure, setMaxTenure] = useState("00"); // constant.MAX_TENURE.value);
  const minLoanIPOAmount = Number(20); // constant.MIN_LOAN_AMT.value);
  const minProcessingFee = Number(200); // constant.MIN_PROCESSING_FEE.value);
  const [minTenure, setMinTenure] = useState("00"); // constant.MIN_TENURE.value);
  const processingFeeROI = Number(10); // constant.ROI_PROCESSING_FEE.value);
  const [selectedLoanAmount, setSelectedLoanAmount] = useState("400000");
  const [approvedLoanAmount, setApprovedLoanAmount] = useState("000000");
  const [pf, setPf] = useState("0000");
  const [maxEmi, setMaxEmi] = useState("00000");
  const [emi, setEmi] = useState("00000");
  const [resendOtp, setResendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [tenure, setTenure] = useState("00");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const [lastSelectedLoanAmount, setLastSelectedLoanAmount] =
    useState("000000");
  const [fetchData, setFetchedData] = useState(false);
  const [maxApprovedEMIAmount, setMaxApprovedEMIAmount] =
    useState(2000000000000);
  const [processingFee, setProcessingFee] = useState(0);
  const [ischecked, setIsChecked] = useState(false);
  const [insuranceCheckBox, setInsuranceCheckBox] = useState(true);
  const [Insurance, setInsurance] = useState(0);
  const [viewBreakup, setViewBreakup] = useState(false);
  const [totalCharges, setTotalCharges] = useState(0);
  const [zumigoFailed, setZumigoFailed] = useState(false);
  const [internetCheck, setInternetCheck] = useState(false);
  const [foreclosureAmountFail, setForeclosureAmountFail] = useState(false);
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [showShimmer, setShowShimmer] = useState(true);
  const [dataCaptured, setDataCaptured] = useState();
  const [tncDoc, setTncDoc] = useState("");
  const [tncIframeModal, setTncIframeModal] = useState(false);
  const [insuranceTncConsent, setInsuranceTncConsent] = useState(false)

  useEffect(() => {

    isStageLogin(    
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    setTncDoc(`${customerDetails?.Data?.tncPdf}`);
  }, []);

  useEffect(() => {
    // console.log("USECONTEXT>>>>>>>>>>>>>", customerDetails);
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("ReviewPage customerDetails: ", customerDetails);
      setShowShimmer(false);
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      // console.log(customerDetails.Data.foreclosure_amount);
      // console.log(customerDetails);
      // if (customerDetails?.Data?.is_karza_response_recieved === "False") {
      //   var route = getRouteFromLoanStageService({
      //     source: customerDetails.source,
      //     stage: "error",
      //   });
      //   navigate(`${route}`, {
      //     replace: true,
      //     state: {
      //       customerDetails: customerDetails,
      //     },
      //   });
      // } else {
      // }
      if (customerDetails.source === "upsell") {
        if (
          customerDetails?.Data?.foreclosure_amount === "None" ||
          customerDetails?.Data?.foreclosure_amount === null
        ) {
          setForeclosureAmountFail(true);
        }
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
      if (customerDetails.stage === "REVIEW_EMPLOYMENT_VERIFY") {
        resendOTP();
      }
    } else {
      // console.log("ReviewPage Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(async () => {}, [customerDetails]);

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, [dataCaptured]);

  const handleCheckBox = async () => {
    setIsChecked(!ischecked);
    // console.log("checkBox clicked");
  };

  useEffect(() => {
    moengage.track_event("Review Insurance", {
      opted_for_insurance:insuranceCheckBox?"YES":"NO",
      "journey name": customerDetails.source,
      insurance_premium: Math.round(parseFloat(customerDetails?.Data?.emi_protect_ins) + parseFloat(customerDetails?.Data?.accident_coverage_ins))
    });
  }, [insuranceCheckBox])
  
  useEffect(() => {
    setTotalCharges(
      parseInt(customerDetails?.Data?.processing_fees_amount) +
        parseInt(
          customerDetails?.source === "upsell"
            ? customerDetails?.Data?.foreclosure_amount
            : 0
        )
    );

    setInsurance(
      parseFloat(customerDetails?.Data?.emi_protect_ins) +
        parseFloat(customerDetails?.Data?.accident_coverage_ins)
    );
  }, [customerDetails]);

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  const resendOTP = async () => {
    var payload = {
      email: customerDetails?.Data?.org_email_id,
      mode: "EMPLOYMENT_CHECK",
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + SEND_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowOtpModal(false);
        // console.log("Otp sent");
        setShowShimmer(false);
        setResendOtp(true);
        SetEnableResendOtp(false);
        setMinutes(2);
        setSeconds(59);
        resetOTP();
      }
      if (response.response.ErrorType == "OTP_MAX_RETRY") {
        // console.log("Maximum retry reached");
        let min = parseInt(parseInt(response?.response.Data.retryTimer) / 60);
        let sec = parseInt(parseInt(response?.response.Data.retryTimer) % 60);
        setShowShimmer(false);
        setShowMaxRetryModal(true);
        setMinutes(min);
        setSeconds(sec + 2);
        SetEnableResendOtp(false);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const VerifyOTPOnEmail = async () => {
    try {
      var payload = {
        otp: otp,
        email: customerDetails?.Data?.org_email_id,
        mode: "EMPLOYMENT_CHECK",
      };
      setShowOtpModal(false);
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + VERIFY_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowShimmer(false);
        // console.log("Otp Verified");
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      }
      if (response.response.ErrorType == "INVALID_OTP") {
        setShowShimmer(false);
        // console.log("incorrect");
        SetIsOtpWrong(true);
      }
      if (response.response.ErrorType == "OTP_EXPIRED") {
        setShowShimmer(false);
        setShowOtpExpiredModal(true);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const openPDFiFrame = () => {
    var fileName = "Insurance TnC";
    downloadPDF(tncDoc, fileName);
}
function downloadPDF(pdfData, pdfFileName) {
  // // console.log("Downloading ", pdfFileName);
  // // console.log("pdfData ", pdfData);
  const linkSource = pdfData;
  // // console.log("linkSource ", linkSource);
  const downloadLink = document.createElement("a");
  const fileName = pdfFileName + ".pdf";
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
  // // console.log("Downloaded ", pdfFileName);
}
  const changeAmount = async () => {
    let custInsChoice = "NO";
    if (insuranceCheckBox) {
      custInsChoice = "YES";
    }
    const formData = new FormData();
    const requestData = {
      current_stage: customerDetails.stage,
      stage_conditions: {
        amountChanged: true,
      },
    };
    formData.append("data", encryptedData(requestData));
    try {
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + REVIEW_IPO,
        formData
      );
      setShowShimmer(false);
      // console.log("INSERT_IPO response: ", response);
      if (response.response.Success === true) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            60,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            60,
            customerDetails.application_form_number
          );
        }
        // console.log(response.response.STAGE);
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        console.error(`EMI Check Failed!`);
      }
    } catch (error) {
      if (error.message === "API call cancelled due to connectivity issue") {
        setInternetCheck(true);
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            73,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            73,
            customerDetails.application_form_number
          );
        }
      }
      setShowShimmer(false);
      console.error(`Unknown Error: ${error}`);
    }
  };

  const toggleViewBreakup = () => {
    setViewBreakup(!viewBreakup);
  };

  const reviewLoanIPO = async () => {
    try {
      let custInsChoice = "NO";
      if (insuranceCheckBox) {
        custInsChoice = "YES";
      }
      moengage.track_event("Review loan amount", {
        "final loan amount": customerDetails?.Data?.cust_accepted_loan_amount,
        "journey name": customerDetails.source,
      });
      const formData = new FormData();
      const requestData = {
        current_stage: customerDetails.stage,
        stage_conditions: {
          amountChanged: false,
        },
      };
      if (customerDetails.source === "epl") {
        requestData.cust_ins_choice = custInsChoice;
      }
      formData.append("data", encryptedData(requestData));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + REVIEW_IPO,
          formData
        );
        setShowShimmer(false);
        console.log("INSERT_IPO response: ", response);
        if (response.response.Success === true) {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              61,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              61,
              customerDetails.application_form_number
            );
          }
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
        } else {
          console.error(`EMI Check Failed!`);
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              73,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              73,
              customerDetails.application_form_number
            );
          }
        }
        setShowShimmer(false);
        console.error(`Unknown Error: ${error}`);
      }
    } catch (error) {
      if (error.message === "API call cancelled due to connectivity issue") {
        setInternetCheck(true);
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            73,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            73,
            customerDetails.application_form_number
          );
        }
      }
      setShowShimmer(false);
      // console.log(error);
    }
  };

  const maskData = (data) => {
    if ([undefined, null, "None", ""].includes(data)) {
      return "None";
    }
    var maskedData = "";
    for (var i = 0; i < data.length; i++) {
      if (i < data.length - 4) {
        maskedData += "*";
      } else {
        maskedData += data[i];
      }
    }
    return maskedData;
  };

  const handleProceed = () => {
    // Check if the TNC URL is valid before setting it
    if (
      insuranceCheckBox &&
      tncDoc &&
      typeof tncDoc === "string" &&
      tncDoc.trim() !== ""
    ) {
      setTncIframeModal(true);
    } else {
      reviewLoanIPO();
    }
  };

  const handleOkClick = async () => {
    const payload = {
      insurance_acceptance_of_tnc: insuranceCheckBox,
    }
    const src = customerDetails.source;

    await userConsentStatus(payload, src);
    await reviewLoanIPO();
  }

  return (
    <>
      <ProgressBar showProgress={true} currentStep={6} />
      <IncorrectOtpModal
        isOpen={isOtpwrong}
        onClose={() => {
          SetIsOtpWrong(false);
          setShowOtpModal(true);
          resetOTP();
        }}
      />
      <MaxOtpRetryModal
        isOpen={showMaxRetryModal}
        onClose={() => {
          setShowMaxRetryModal(false);
          SetEnableResendOtp(false);
          setResendOtp(false);
          setShowOtpModal(true);
          resetOTP();
        }}
      />
      <OtpExpiredModal
        isOpen={showOtpExpiredModal}
        onClose={() => {
          resendOTP();
          setShowOtpExpiredModal(false);
          setShowOtpModal(true);
          SetEnableResendOtp(false);
          setMinutes(2)
          setSeconds(59);
          resetOTP();
        }}
      />
      <ResendOtpEmailModal
        isOpen={resendOtp}
        onClose={() => {
          setShowOtpModal(true);
          SetEnableResendOtp(false);
          setResendOtp(false);
          setMinutes(2)
          setSeconds(59);
          resetOTP();
        }}
      />

      <Modal
        open={showOtpModal}
        showCloseButton={false}
        closeonClickOutside={false}
        onClose={() => {
          // setShowOtpModal(false);
        }}
        id="bd-email-otp-parent"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div
              className="modal-body"
              style={{
                border: "1px solid #A7A7A7",
                padding: "1rem",
              }}
            >
              <div className="pupup-inner">
                <div className="title text-center">
                  <h2 className="fs-36 font-weight-medium text-black mb-2 lh-1">
                    Verify Office Email{" "}
                  </h2>
                  <p className="fs-20 font-weight-medium text-black mb-4 pb-2 lh-1">
                    by entering OTP
                  </p>
                </div>
                <form>
                  <div
                    style={{
                      marginLeft: "10px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    <div>
                      <OTPInput
                        length={6}
                        otpDigits={otpDigits}
                        setOtpDigits={setOtpDigits}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      color: "#717171",
                      fontSize: "12px",
                      marginTop: "10px",
                      marginBottom: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {enableResendOtp ? (
                        <></>
                      ) : (
                        <>
                          <img
                            style={{
                              height: "15px",
                              width: "15px",
                              justifyContent: "center",
                              marginRight: "4px",
                            }}
                            src={timer}
                          />
                        </>
                      )}
                      <text
                        style={{
                          border: "None",
                          backgroundColor: "white",
                          color: enableResendOtp ? "#3C94FC" : "grey",
                          marginRight: "5px",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          resendOTP();
                        }}
                      >
                        Re-send OTP
                      </text>
                    </div>
                    {enableResendOtp ? (
                      <></>
                    ) : (
                      <>
                        <div>
                          in {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="col-12 col-md-10 col-lg-8 col-xl-8 mx-auto">
                    <div className="col-wrap text-center">
                      <Button
                        id="VerifyOTP"
                        className="Btn VerifyOTP"
                        disabled={!isOtpValid}
                        mobile={isMobile}
                        onClick={async () => {
                          await VerifyOTPOnEmail();
                        }}
                        text={"Verify"}
                      />
                    </div>
                  </div>
                  <p
                    style={{
                      textAlign: "center",
                      paddingTop: "15px",
                    }}
                  >
                    6 digit verification code sent to office email ID will be
                    valid for next 5 minutes.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <CheckInternetModal
        isOpen={internetCheck}
        onClose={() => {
          setInternetCheck(false);
          setShowShimmer(false);
        }}
      />
      <ZumigoFailed
        isOpen={zumigoFailed}
        onClose={() => {
          setZumigoFailed(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <ForeclosureChargesModal
        isOpen={foreclosureAmountFail}
        onClose={() => {
          setForeclosureAmountFail(false);
          const currentURL = window.location.href;
          const lastSlashIndex = currentURL.lastIndexOf("/");
          const resultURL = currentURL.slice(0, lastSlashIndex);
          window.location.replace(resultURL + "/login");
        }}
      />
      <AfterLoginLayoutWrapper width={"100%"}>
      <Suspense fallback={<FallbackLoader />}>
          {tncIframeModal && (
            <PdfModal
              isOpen={tncIframeModal}
              url={tncDoc}
              okButtonText="Agree"
              onOk={handleOkClick}
              showSecondButton={true}
              onSecondButtonClick={() => {
                setTncIframeModal(false);
                setInsuranceCheckBox(false);
              }}
            />
          )}
        </Suspense>
        <Loading
          open={modal === "LOADING_CKYC"}
          msg="Please wait while we verify your details."
        />
        <Loading open={modal === "LOADING"} />
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <StyleWrapper>
          <ShimmerPlaceholder
            height="2.5em"
            width="15em"
            marginTop="1em"
            visible={showShimmer}
          />
          <Title
            id="pageTitle"
            className="pageTitle"
            text={`Review your Loan Plan`}
            visible={!showShimmer}
            clickable={false}
          />
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                height="12em"
                width="25em"
                marginTop="1em"
                visible={showShimmer}
              />
              <ShimmerPlaceholder
                height="14em"
                width="25em"
                marginTop="2em"
                visible={showShimmer}
              />
            </>
          ) : (
            <>
              <div className="review-box">
                <div className="review-row">
                  <div className="review-title">
                    {customerDetails?.source === "upsell"
                      ? "Top-up Loan Amount"
                      : "Loan Amount"}
                  </div>
                  <div className="review-value">
                    {appendRupee(
                      customerDetails?.Data?.cust_accepted_loan_amount || "0"
                    )}
                  </div>
                </div>
                {/* <div className="review-row flex-end">
              <div className="review-title"></div>
              <button className="review-button" onClick={changeAmount}>
                Change Amount
              </button>
            </div> */}
                <div className="review-row">
                  <div className="review-title">Charges</div>
                  <div className="review-value">
                    {/* (-) {appendRupee(totalCharges)} */}

                    (-){" "}
                    {appendRupee(
                      Math.round(
                        insuranceCheckBox && customerDetails?.source == "epl"
                          ? totalCharges + Insurance
                          : totalCharges
                      )
                    )}
                  </div>
                </div>

              {customerDetails?.source == "epl"?
                <div
                  className="review-row"
                  style={{ fontSize: "larger", fontWeight: "bold" }}
                >
                  <div className="insurance-checkbox">
                    <CheckField
                      id="basic-ckeckfield"
                      checked={insuranceCheckBox}
                      label=""
                      style={{
                        fontSize: "15px",
                        marginLeft: "15px",
                      }}
                      onClick={() => {
                        setInsuranceCheckBox(!insuranceCheckBox);
                        setInsuranceTncConsent(!insuranceTncConsent);
                      }}
                    />
                    <div className=" review-title insurance-field">
                      Insurance
                    </div>
                  </div>
                  <div
                    className="review-value"
                    style={{ fontSize: "large", fontWeight: "bold" }}
                  >
                    {appendRupee(Math.round(Insurance))}
                  </div>
                </div>:
                <></>
            }
                <div className="review-row flex-end">
                {customerDetails?.source == "epl"?
                  <div>
                    <button
                      className="review-button"
                      style={{ marginLeft: "27px" }}
                      onClick={() => openPDFiFrame()}
                    >
                      Know More
                    </button>
                  </div>:
                  <></>
                }
                  <div className="review-title"></div>
                  <button className="review-button" onClick={toggleViewBreakup}>
                    {viewBreakup ? "Hide Breakup" : "View Breakup"}
                  </button>
                </div>
                {viewBreakup ? (
                  <>
                    <div className="review-row">
                      <div className="review-title">Processing Fees</div>
                      <div className="review-value">
                        (-){" "}
                        {appendRupee(
                          customerDetails?.Data?.processing_fees_amount || "0"
                        )}
                      </div>
                    </div>
                    {insuranceCheckBox && customerDetails?.source == "epl"? (
                      <div className="review-row">
                        <div className="review-title">Insurance Amount</div>
                        <div className="review-value">
                          (-) {appendRupee(Math.round(Insurance) || "0")}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    {customerDetails?.source === "upsell" ? (
                      <>
                        {Object.keys(
                          JSON.parse(
                            customerDetails?.Data?.foreclosure_charges_master.replace(
                              /'/g,
                              '"'
                            )
                          )
                        ).map((key) => (
                          key !== "sum_charge" && (
                          <div key={key} className="review-row">
                            <div className="review-title">
                              {key
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (match) =>
                                  match.toUpperCase()
                                )}
                            </div>
                            <div className="review-value">
                              (-){" "}
                              {appendRupee(
                                JSON.parse(
                                  customerDetails?.Data?.foreclosure_charges_master.replace(
                                    /'/g,
                                    '"'
                                  )
                                )[key]
                              )}
                            </div>
                          </div>
                        )))}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}
                <div className="colored-box">
                  <div className="review-row">
                    <div className="review-title colored-text">
                      Disbursal Amount
                    </div>
                    <div className="review-value colored-text">
                      {/* {appendRupee(
                        (customerDetails?.Data?.cust_accepted_loan_amount ||
                          0) - totalCharges
                      )} */}
                      {insuranceCheckBox && customerDetails?.source == "epl"
                        ? appendRupee(
                            (customerDetails?.Data?.cust_accepted_loan_amount ||
                              0) -
                              totalCharges -
                              Math.round(Insurance)
                          )
                        : appendRupee(
                            (customerDetails?.Data?.cust_accepted_loan_amount ||
                              0) - totalCharges
                          )}
                    </div>
                  </div>
                  <div className="review-row flex-start">
                    <div className="review-title">
                      Will be disbursed to your bank account
                    </div>
                  </div>
                  {/* <div className="review-row flex-start">
                    <Button
                      id="Btn"
                      className="Btn"
                      mobile={isMobile}
                      disabled={false}
                      text={"Change Amount"}
                      style={{
                        marginTop: "10px",
                      }}
                      onClick={changeAmount}
                    />
                  </div> */}
                </div>
              </div>
              <div className="review-bottom-behind-box">
                <div className="review-data-box">
                  <div className="review-block">
                    <div className="review-title">Monthly Installment</div>
                    <div className="review-value">
                      {appendRupee(
                        customerDetails?.Data?.cust_accepted_emi || 0
                      )}
                    </div>
                    <div className="review-message">
                      5<sup>th</sup> of every month
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Interest Rate</div>
                    <div className="review-value">
                      {(customerDetails?.Data?.roi || 0) + "% p.a."}
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Tenure</div>
                    <div className="review-value">
                      {(customerDetails?.Data?.tenure || 0) + " Months"}
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">
                      {customerDetails?.source === "upsell"
                        ? "Total Loan Amount"
                        : "Bank Account"}
                    </div>
                    <div className="review-value">
                      {customerDetails?.source === "upsell"
                        ? appendRupee(
                            parseInt(customerDetails?.Data?.old_loan_amount) +
                              parseInt(
                                customerDetails?.Data?.cust_accepted_loan_amount
                              )
                          )
                        : maskData(customerDetails?.Data?.account_number) ||
                          "None"}
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Annual Percentage Rate (APR)</div>
                    <div className="review-value">{insuranceCheckBox?(customerDetails?.Data?.with_ins):(customerDetails?.Data?.without_ins)}% p.a.</div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Part Prepayment Charges*</div>
                    <div className="review-value">NIL</div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Foreclosure Charges*</div>
                    <div className="review-value">4% of the principal outstanding amount for term loan + GST</div>
                  </div>
                </div>
                <div className="review-block bottom">
                  <div className="review-message">
                    *Will be available after 12th EMI Payment
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="bottomDiv only-btn">
            {showShimmer ? (
              <>
                {/* <ShimmerPlaceholder
                  height="3em"
                  width="25em"
                  marginTop="-0.5em"
                  visible={showShimmer}
                /> */}
                <ShimmerPlaceholder
                  height="2.5em"
                  width="10em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                {/* <SubTitle
                  id="pageSubTitle"
                  className="pageSubTitle"
                  text={
                    "I acknowledged that I have read, and do hereby accept the terms and conditions contained in the loan agreement."
                  }
                  visible={true}
                  clickable={false}
                  style={{ fontSize: "1.2rem" }}
                /> */}
                <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  disabled={false}
                  text={"Proceed"}
                  onClick={handleProceed}
                  // 	() => {
                  // 		navigate("/bank-details", {
                  // 		replace: true,
                  // 		state: {
                  // 			customerDetails: customerDetails,
                  // 		},
                  // 	});
                  // }}
                />
              </>
            )}
          </div>
        </StyleWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default ReviewDetails;
